<h1 mat-dialog-title>Permissões de cada Perfil</h1>
<div mat-dialog-content>
  - Administrador de Carteira (Cadastrar tarifas, cadastrar, editar e bloquear usuários do tipo analista, cadastrar e editar parceiros);<br>
  - Administrador Sênior (Permissão a todas as funções)<br>
  - Analista de Carteira (cadastrar tarifas, aprovar solicitações de clientes de carteira específica);<br>
  - Analista de Sênior (cadastrar tarifas, aprovar solicitações de clientes de todas carteiras);<br>
</div>


